import { Navigate, RouteObject } from 'react-router-dom';
import { NotFound } from '@/pages/NotFound';
import { MainLayout } from '@/pages/MainLayout';
import { UsualTable } from '@/widgets/UsualTable';
import { ClubTable } from '@/widgets/ClubTable';
import { MaxAdminPage } from '@/pages/MaxAdminPage';
import { NewsPage } from '@/pages/NewsPage';
import { PushPage } from '@/pages/PushPage';
import { BillingTariffsPage } from '@/pages/BillingTariffsPage';

export const routeConfig: RouteObject[] = [
  {
    element: <MainLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: '/usual',
        element: <UsualTable />,
      },
      {
        path: '/club',
        element: <ClubTable />,
      },
      {
        path: '/max',
        element: <MaxAdminPage />,
      },
      {
        path: '/news',
        element: <NewsPage />,
      },
      {
        path: '/push',
        element: <PushPage />,
      },
      {
        path: '/tariffs',
        element: <BillingTariffsPage />,
      },
      {
        path: '/news/create',
        element: <NewsPage />,
      },
      {
        path: '/news/:id/edit',
        element: <NewsPage />,
      },
      {
        path: '',
        element: <Navigate to={'usual'} replace />,
      },
      {
        path: '/login',
        element: <Navigate to={'/usual'} replace />,
      },
    ],
  },
];
